export type ClickHandler = (ev: PointerEvent) => void;


export function createDiv(className?: string, textContent?: string): HTMLDivElement
{
    const result = document.createElement("div");
    if (typeof className !== 'undefined' && className !== null) {
        result.className = className;
    }
    if (typeof textContent !== 'undefined' && textContent !== null) {
        result.textContent = textContent;
    }
    return result;
}


export function createButton(className?: string, innerHTML?: string, callback?: ClickHandler): HTMLButtonElement
{
    const result = document.createElement("button");
    if (typeof className !== 'undefined' && className !== null) {
        result.className = className;
    }
    if (typeof innerHTML !== 'undefined' && innerHTML !== null) {
        result.innerHTML = innerHTML;
    }
    if (typeof callback !== 'undefined' && callback !== null) {
        result.addEventListener("click", ev => callback(ev));
    }
    return result;
}


export function createTextInput(label: string, obj: any, key: string): HTMLDivElement
{
    const rowElement = document.createElement("div");
    rowElement.classList.add("row");

    if (label !== null) {
        const labelElement = rowElement.appendChild(document.createElement("div"));
        labelElement.classList.add("label");
        labelElement.textContent = label;
    }

    const inputElement = rowElement.appendChild(document.createElement("input"));
    inputElement.value = obj[key];
    inputElement.addEventListener("change", () => {
        obj[key] = inputElement.value;
    });

    return rowElement;
}
